import { render, staticRenderFns } from "./EditPageButton.vue?vue&type=template&id=16d8f364&scoped=true&"
import script from "./EditPageButton.vue?vue&type=script&lang=js&"
export * from "./EditPageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d8f364",
  null
  
)

export default component.exports